/** @format */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filterId: "",
  filterName: "",
  filterMobileNumber: "",
  filterEmail: "",
  filterStatus: "",
  filterFromDate: "",
  filterToDate: "",
  filterFromDateForCreate: "",
  filterToDateForCreate: "",
  filterClearFilterFlag: 0,
};

const PaymentLinkFilterSlice = createSlice({
  name: "paymentLinkFilter",
  initialState,
  reducers: {
    setFilterId(state, action) {
      state.filterId = action.payload;
    },
    setFilterName(state, action) {
      state.filterName = action.payload;
    },
    setFilterMobileNumber(state, action) {
      state.filterMobileNumber = action.payload;
    },
    setFilterEmail(state, action) {
      state.filterEmail = action.payload;
    },
    setFilterStatus(state, action) {
      state.filterStatus = action.payload;
    },
    setFilterFromDate(state, action) {
      state.filterFromDate = action.payload;
    },
    setFilterToDate(state, action) {
      state.filterToDate = action.payload;
    },
    setFilterClearFilterFlag(state, action) {
      state.filterClearFilterFlag = action.payload;
    },
    setFilterRequestedBy(state, action) {
      state.filterRequestedBy = action.payload;
    },
    reset(state) {
      state.filterId = "";
      state.filterName = "";
      state.filterMobileNumber = "";
      state.filterEmail = "";
      state.filterStatus = "";
      state.filterFromDate = "";
      state.filterToDate = "";
      state.filterFromDateForCreate = "";
      state.filterToDateForCreate = "";
      state.filterClearFilterFlag = 0;
      state.filterRequestedBy="";
    },

    setFilterFromDateForCreate(state, action) {
      state.filterFromDateForCreate = action.payload;
    },
    setFilterToDateForCreate(state, action) {
      state.filterToDateForCreate = action.payload;
    },
  },
});

export const {
  setFilterId,
  setFilterName,
  setFilterMobileNumber,
  setFilterEmail,
  setFilterStatus,
  setFilterFromDate,
  setFilterToDate,
  setFilterFromDateForCreate,
  setFilterToDateForCreate,
  setFilterClearFilterFlag,
  reset,
  setFilterRequestedBy,
} = PaymentLinkFilterSlice.actions;

export default PaymentLinkFilterSlice.reducer;
